import { render, staticRenderFns } from "./RecommendBlock.vue?vue&type=template&id=28c14cc6&scoped=true"
import script from "./RecommendBlock.vue?vue&type=script&lang=js"
export * from "./RecommendBlock.vue?vue&type=script&lang=js"
import style0 from "./RecommendBlock.vue?vue&type=style&index=0&id=28c14cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c14cc6",
  null
  
)

export default component.exports